import React, { useState, useEffect } from 'react'
import {useTranslation} from "react-i18next";
import SettingsHeader from './console/SettingsHeader';

function ConfirmEmail(){
    const { t } = useTranslation(['confirm_email', 'base']);

    return(
        <>
            <SettingsHeader />
            <div style={{padding: "40px"}}>
                <h1>{t('string_1')}</h1>
                <p>{t('string_2')}</p>
            </div>
        </>
    )
}

export default ConfirmEmail;
